var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _circle4, _path11, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_13",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 245.98 46.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_145);}.cls-2{fill:url(#\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_127);}.cls-3{fill:url(#\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_72);}.cls-4{fill:#316da6;}.cls-5,.cls-9{fill:#ed723d;}.cls-6{fill:#fac970;}.cls-10,.cls-7{fill:#4974aa;}.cls-8{fill:#fff;}.cls-9{opacity:0.37;}.cls-10{opacity:0.38;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_145",
    x1: 57.68,
    y1: -51.99,
    x2: 78.09,
    y2: -87.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003d69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#155183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#246196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2e6aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#316da6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_127",
    x1: 51.95,
    y1: -51.72,
    x2: 92.77,
    y2: -51.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e83b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e63b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#df3c36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d33e38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c2403a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ac433d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#914641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_72",
    x1: 75.57,
    y1: -82.37,
    x2: 95.98,
    y2: -47.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a782c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#a58c34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c3a33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d8b342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e5bd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e9c047"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.71-85.36,53-54.69l9.37,5.4L80.07-80a5.39,5.39,0,0,0-2-7.38A5.4,5.4,0,0,0,70.71-85.36Z",
    transform: "translate(-51.95 93.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.35-57.13H92.77v10.81H57.35a5.4,5.4,0,0,1-5.4-5.4A5.41,5.41,0,0,1,57.35-57.13Z",
    transform: "translate(-51.95 93.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98-54.4,87.16-73.11h0l-6.9-12-9.37,5.4,6.5,11.25h0L88.6-49A5.4,5.4,0,0,0,96-47,5.39,5.39,0,0,0,98-54.4Z",
    transform: "translate(-51.95 93.11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.26-69.89,80.07-80a5.39,5.39,0,0,0-2-7.38,5.4,5.4,0,0,0-7.38,2L64.48-74.57",
    transform: "translate(-51.95 93.11)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 5.42,
    cy: 41.4,
    r: 5.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 41.32,
    cy: 41.4,
    r: 5.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 23.43,
    cy: 10.46,
    r: 5.42
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M180.76-68.2h0a143.45,143.45,0,0,0-17.12-5.35.49.49,0,0,1-.4-.54V-86.71h-10v35.45h0a.66.66,0,0,0,0,.14,4.89,4.89,0,0,0,5,4.81,4.9,4.9,0,0,0,5-4.81c0-.05,0-.09,0-.14h0V-64.35a.38.38,0,0,1,.15-.27.31.31,0,0,1,.3-.07c5.44,1.51,9.2,2.67,14.07,4.51h0a4.47,4.47,0,0,0,1.64.31,4.34,4.34,0,0,0,4.41-4.26A4.29,4.29,0,0,0,180.76-68.2Z",
    transform: "translate(-51.95 93.11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.78-74.43h-9.7v2.84h0a.78.78,0,0,0,0,.14c-.14,4.61-.7,8-1.68,10.28s-4.2,4.67-6.79,6.23c0,0,0,0,0,0a4.56,4.56,0,0,0-2.41,4,4.49,4.49,0,0,0,4.15,4.53h0l.24,0a4.17,4.17,0,0,0,.71-.07,9.41,9.41,0,0,0,3.77-1.17c4.14-2.47,7.13-5.32,8.85-8.76s2.66-8.48,2.83-15.14c0,0,0-.09,0-.14h0Z",
    transform: "translate(-51.95 93.11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M271.28-65.09a4.81,4.81,0,0,0,4.84-4.78,2.44,2.44,0,0,0,0-.27h0V-86.71h-9.69v16.57h0a2.45,2.45,0,0,0,0,.27A4.81,4.81,0,0,0,271.28-65.09Z",
    transform: "translate(-51.95 93.11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M262.39-90.74a7.15,7.15,0,0,0-5.4-2.37,7.15,7.15,0,0,0-4.87,1.86,7.92,7.92,0,0,0-2.63,4.65c-.07.33-.24.49-.51.49H227.75a4.33,4.33,0,0,0-4.2,4.45,4.33,4.33,0,0,0,4.2,4.44h19.34c.31,0,.43.17.36.49q-1.57,9.15-6.94,14.4c-3.51,3.45-7.12,5.55-13.44,6.88l-.06,0-.22,0v0a4.57,4.57,0,0,0-3.24,4.45,4.5,4.5,0,0,0,4.37,4.62,4.07,4.07,0,0,0,.5,0v0c8.6-1.43,14.3-4.25,19-8.76S255.39-66,257-74.26v-.07h0l.51-2.65a7.15,7.15,0,0,0,4.88-2.35,8,8,0,0,0,2.25-5.7A8,8,0,0,0,262.39-90.74Zm-2.85,7.86a3.13,3.13,0,0,1-2.35,1,3.13,3.13,0,0,1-2.35-1,3.5,3.5,0,0,1-1-2.48,3.5,3.5,0,0,1,1-2.48,3.13,3.13,0,0,1,2.35-1,3.13,3.13,0,0,1,2.35,1,3.49,3.49,0,0,1,1,2.48A3.49,3.49,0,0,1,259.54-82.88Z",
    transform: "translate(-51.95 93.11)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M218.37-86.71h-32a4.26,4.26,0,0,0-4.2,4.31,4.26,4.26,0,0,0,4.2,4.32h23.69a.25.25,0,0,1,.23.15.22.22,0,0,1,0,.26,31.76,31.76,0,0,1-4.72,6.31l0,0a4.68,4.68,0,0,0-1,2.85,4.91,4.91,0,0,0,5,4.82,5.07,5.07,0,0,0,3.33-1.24h0L213-65l.23-.22a30.1,30.1,0,0,0,6.94-10.11,13.72,13.72,0,0,0,1.12-5.75v-5.65Z",
    transform: "translate(-51.95 93.11)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M148.1-54.72l-.26-.28v0c-3.57-3.61-5.62-5.62-8.75-8.63-.24-.19-.26-.43,0-.73a50,50,0,0,0,6-10.22,15.12,15.12,0,0,0,1.18-6.08v-2.85s0,0,0-.08v-3.1H117.45l-.2,0-.44,0a4.69,4.69,0,0,0-4.77,4.6,4.69,4.69,0,0,0,4.77,4.61l.44,0,.2,0H135c.3,0,.39.15.25.45a38.75,38.75,0,0,1-9.21,12.9,52.61,52.61,0,0,1-12.4,8.82l-.06,0-.15.09h0A4.76,4.76,0,0,0,111-51.1a4.89,4.89,0,0,0,5,4.79,5.11,5.11,0,0,0,2.55-.68h0c6.32-2.68,8.46-4.76,13.49-9.52.27-.23.51-.25.71-.06,3.17,3,5.09,4.91,8.33,8.31a4.45,4.45,0,0,0,3.63,2l.37,0h0A4.79,4.79,0,0,0,150-51,4.64,4.64,0,0,0,148.1-54.72Z",
    transform: "translate(-51.95 93.11)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 64.7,
    cy: 11.01,
    r: 4.61
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295-86.71h-7v17.35a28.15,28.15,0,0,1-.34,5,7.49,7.49,0,0,1-2.78,4.06,13.81,13.81,0,0,1-4.79,2.84A27.29,27.29,0,0,1,273.62-56h-.06A4.86,4.86,0,0,0,269-51.16a4.86,4.86,0,0,0,4.86,4.85h.76c8.61-.87,14-3.07,17.71-6.76s5.61-9.12,5.61-16.29V-86.71Z",
    transform: "translate(-51.95 93.11)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 221.89,
    cy: 41.95,
    r: 4.86
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c66aa6d0728fff92ebb7157a658dd61.svg";
export { ForwardRef as ReactComponent };